import {
  ActionIcon,
  Button,
  Card,
  createTheme,
  NavLink,
  Paper,
  SegmentedControl,
  Textarea,
  TextInput,
  type MantineColorsTuple,
} from '@mantine/core'

/** Ближе к бренду TOIS / основному фронту (--accent ~ #6c7ae0, --primary ~ #7c3aed) */
const brand: MantineColorsTuple = [
  '#f0f1fc',
  '#dcd8f8',
  '#c4bdf2',
  '#9b94e8',
  '#7b7adb',
  '#6c6fd4',
  '#5c5fc9',
  '#4a4db0',
  '#3d4190',
  '#323674',
]

const transition = '150ms cubic-bezier(0.4, 0, 0.2, 1)'
const transitionLong = '200ms cubic-bezier(0.22, 1, 0.36, 1)'

const fontSans =
  "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif"

export const mantineTheme = createTheme({
  /** Десктоп с боковой панелью и двухколоночные экраны — от 1280px (`80em` при 16px). */
  breakpoints: {
    xs: '36em',
    sm: '48em',
    md: '62em',
    lg: '80em',
    xl: '96em',
  },
  primaryColor: 'brand',
  colors: { brand },
  fontFamily: fontSans,
  fontFamilyMonospace: "'JetBrains Mono', ui-monospace, monospace",
  headings: {
    fontFamily: fontSans,
    fontWeight: '600',
  },
  defaultRadius: 'md',
  focusRing: 'auto',
  components: {
    /**
     * Ручка нативного resize: визуально слева снизу — обёртка `direction: rtl`, само поле LTR.
     * Однострочные `TextInput` не затрагиваются.
     */
    Textarea: Textarea.extend({
      defaultProps: { resize: 'both' },
      styles: {
        wrapper: { direction: 'rtl' },
        input: {
          direction: 'ltr',
          textAlign: 'left',
          overflow: 'auto',
          minWidth: 'min(100%, 12rem)',
          maxWidth: '100%',
          transition: `border-color ${transition}, box-shadow ${transition}`,
        },
      },
    }),
    TextInput: TextInput.extend({
      styles: {
        input: {
          transition: `border-color ${transition}, box-shadow ${transition}`,
        },
      },
    }),
    Button: Button.extend({
      styles: {
        root: {
          transition: `background ${transition}, border-color ${transition}, color ${transition}, opacity ${transition}`,
        },
      },
    }),
    ActionIcon: ActionIcon.extend({
      styles: {
        root: {
          transition: `background ${transition}, border-color ${transition}, color ${transition}, transform ${transitionLong}`,
        },
      },
    }),
    NavLink: NavLink.extend({
      styles: {
        root: {
          transition: `background ${transition}, color ${transition}`,
        },
      },
    }),
    Card: Card.extend({
      styles: {
        root: {
          transition: `box-shadow ${transitionLong}, border-color ${transition}`,
        },
      },
    }),
    Paper: Paper.extend({
      styles: {
        root: {
          transition: `box-shadow ${transitionLong}, border-color ${transition}`,
        },
      },
    }),
    SegmentedControl: SegmentedControl.extend({
      styles: {
        root: {
          transition: `background ${transition}`,
        },
        control: {
          transition: `background ${transition}, border-color ${transition}`,
        },
        label: {
          transition: `color ${transition}, font-weight ${transition}`,
        },
      },
    }),
  },
})
